export default {
  acceptTermsRequired: 'దయచేసి terms and conditions అంగీకరించండి',
  accountNumber: 'A/C Number',
  acknowledgeText: 'అంగీకరించండి',
  acknowledgedText: 'అంగీకరించబడింది',
  active: 'സജീവം',
  activeBookings: 'സജീവ ബുക്കിംഗ്',
  activeBucketsText: 'యాక్టివ్ బకెట్‌లు',
  activeToday: 'ഇന്ന് സജീവം',
  adminRole: 'അഡ്മിൻ — മാനേജിംഗ് ഡയറക്ടർ',
  advance: 'അഡ്വാൻസ്',
  advancePaid: 'അഡ്വാൻസ് അടച്ചു',
  advancePaidLabel: 'అడ్వాన్స్',
  agreeTermsCheckbox: 'నేను అన్ని నిబంధనలు & షరతులు చదివి అంగీకరించాను',
  agreement: 'നിബന്ധനകൾ & കരാർ',
  alertLog: 'അലർട്ട് ലോഗ്',
  alertText: 'హెచ్చరిక',
  alerts: 'അലർട്ടുകൾ',
  allAlerts: 'అన్ని హెచ్చరికలు',
  allLoaded: 'అన్నీ లోడ్',
  allMachinesOk: 'എല്ലാ മെഷീനുകളും ശരിയായി പ്രവർത്തിക്കുന്നു.',
  allStats: 'പൂർണ്ണ കണക്കുകൾ',
  allowedText: 'అనుమతించబడింది',
  amount: 'തുക',
  apiHealthTitle: 'API Health',
  apiSloAlertsTitle: 'API SLO Alerts',
  appName: 'ഡെവലപ്‌മെന്റ് എക്‌സ്‌പ്രസ്',
  approvals: 'ఆమోదాలు',
  approveAndDispatch: 'ఆమోదించి మెషీన్ పంపండి',
  approved: 'ఆమోదించబడింది',
  assignedOperator: 'നിയോഗിച്ച ഓപ്പറേറ്റർ',
  attemptsLabel: 'ప్రయత్నాలు',
  attendance: 'హాజరు',
  auditLogs: 'ఆడిట్ లాగ్‌లు',
  available: 'ലഭ്യം',
  availableMachinery: 'అందుబాటులో ఉన్న మెషినరీ',
  availableNow: 'ഇപ്പോൾ ലഭ്യം',
  avgRating: 'ശരാശരി റേറ്റിംഗ്',
  awaitingClientFeedback: 'గ్రాహకుడు ఫీడ్‌బ్యాక్ కోసం వేచి',
  awaitingDispatch: 'డిస్పాచ్ కోసం వేచి',
  back: 'തിരിച്ചു പോകൂ',
  backToLogin: 'లాగిన్‌కు తిరిగి',
  bank: 'బ్యాంక్',
  bankDetailsTitle: 'బ్యాంక్ వివరాలు',
  baseAmount: 'അടിസ്ഥാന തുക',
  billingWallet: 'വാലറ്റ് & ബില്ലിംഗ്',
  blacklistWarning: '⛔ ബ്ലാക്ക്‌ലിസ്റ്റ് മുന്നറിയിപ്പ്',
  blockedRateText: 'బ్లాక్ రేట్',
  blockedText: 'బ్లాక్ చేయబడింది',
  bookMachine: 'മെഷീൻ ബുക്ക് ചെയ്യൂ',
  bookMachineAction: 'మెషీన్ బుక్ చేయండి',
  bookNow: 'ഇപ്പോൾ ബുക്ക് ചെയ്യൂ',
  bookingConfirm: 'ബുക്കിംഗ് സ്ഥിരീകരിക്കൂ',
  bookingCostCalculator: 'బుకింగ్ & ఖర్చు కాలిక్యులేటర్',
  bookingFailedGeneric: 'ബുക്കിംഗ് പരാജയപ്പെട്ടു. വീണ്ടും ശ്രമിക്കൂ.',
  bookingHistory: 'ബുക്കിംഗ് ചരിത്രം',
  bookingReportTitle: 'బుకింగ్ నివేదిక',
  bookingScheduleSummary: 'రోజు & నెల వారీ బుకింగ్ షెడ్యూల్',
  bookingSelectMachineFirst: 'కొనసాగడానికి ఫ్లీట్ నుండి మెషీన్ ఎంచుకోండి.',
  bookingStepChoose: 'మెషీన్ ఎంచుకోండి',
  bookingStepConfirm: 'నిర్ధారించి చెల్లించండి',
  bookingStepCost: 'ఖర్చు & తేదీలు',
  bookingType: 'ബുക്കിംഗ് തരം തിരഞ്ഞെടുക്കൂ',
  bookingTypeLabel: 'ബുക്കിംഗ് തരം',
  bookingTypeText: 'బుకింగ్ రకం',
  bookingsCount: '{count} ബുക്കിംഗുകൾ',
  bookingsScheduleHint: 'క్లయింట్‌లు బుక్ చేసినప్పుడు రోజువారీ షెడ్యూల్ ఇక్కడ కనిపిస్తుంది.',
  burstText: 'BURST',
  busy: 'തിരക്ക്',
  callNow: 'ఇప్పుడు కాల్ చేయండి',
  cancel: 'റദ്ദാക്കൂ',
  cancelAction: 'రద్దు చేయండి',
  cancelBooking: 'ബുക്കിംഗ് റദ്ദാക്കൂ',
  cancelBookingPrompt: 'బుకింగ్ రద్దు చేయాలా?',
  cancelPolicy: 'റദ്ദാക്കൽ നയം',
  cancelText: 'రద్దు',
  cancelWarning: 'നിങ്ങൾ റദ്ദാക്കണമോ?',
  changeLanguage: 'ഭാഷ മാറ്റൂ',
  changeMachine: 'మెషీన్ మార్చండి',
  changeMobileNumber: 'మొబైల్ నంబర్ మార్చండి',
  chipAction: 'చర్య',
  chipActor: 'నటుడు',
  chipEntity: 'entity',
  chipFrom: 'నుండి',
  chipMeta: 'meta',
  chipRole: 'పాత్ర',
  chipTo: 'వరకు',
  clearAll: 'అన్నీ క్లియర్ చేయండి',
  client: 'ക്ലയന്റ്',
  clientFeedbackLabel: 'గ్రాహకుడు ఫీడ్‌బ్యాక్',
  clientPortal: 'గ్రాహకుల పోర్టల్',
  clientRatingsTitle: 'గ్రాహకుడు రేటింగ్‌లు & సూచనలు',
  clientRole: 'ക്ലയന്റ് (കോൺട്രാക്ടർ)',
  clients: 'ക്ലയന്റുകൾ',
  commission: 'കമ്മീഷൻ',
  commission15: 'కమీషన్ 15%',
  commissionPaid: 'కమీషన్ చెల్లించబడింది',
  commissionRate: 'స్థూల బిల్లింగ్ యొక్క 15%',
  company: 'కంపెనీ',
  companyDetailsTitle: 'కంపెనీ వివరాలు',
  completeBookings: 'പൂർത്തിയായ ബുക്കിംഗ്',
  completedBookings: 'പൂർത്തിയായ ബുക്കിംഗ്',
  condition: 'അവസ്ഥ',
  confirm: 'സ്ഥിരീകരിക്കൂ',
  confirmBooking: 'ബുക്കിംഗ് സ്ഥിരീകരിക്കൂ',
  confirmBookingAction: 'బుకింగ్ నిర్ధారించండి',
  confirmCancel: 'రద్దు నిర్ధారించండి',
  confirmPassword: 'పాస్‌వర్డ్ నిర్ధారించండి',
  confirmRetry: 'మళ్లీ ప్రయత్నం నిర్ధారించండి',
  contactCompany: 'Development Express ను సంప్రదించండి',
  costCalculator: 'ചെലവ് കാൽക്കുലേറ്റർ',
  crawlerNoRto: 'Crawler (RTO లేదు)',
  currentlyDeployed: 'നിലവിൽ ഡിപ്ലോയ്',
  customAmount: 'ഇഷ്ടാനുസൃത തുക (കുറഞ്ഞത് ₹5,000)',
  cycles: "സൈക്കിളുകൾ",
  dailyWorkReport: 'రోజువారీ పని నివేదిక',
  dashboard: 'ഡാഷ്‌ബോർഡ്',
  date: 'തീയതി',
  dayMachinesLabel: 'మెషీన్‌లు',
  days: 'ദിവസം',
  daysUnit: 'ദിവസം',
  directContactBlacklist: 'നേരിട്ടുള്ള ബന്ധം = ബ്ലാക്ക്‌ലിസ്റ്റ്',
  directContactProhibited: 'നേരിട്ടുള്ള ബന്ധപ്പെടൽ കർശനമായി നിരോധിച്ചിരിക്കുന്നു',
  directContactProhibitedText: 'ప్రత్యక్ష సంప్రదింపు కఠినంగా నిషేధించబడింది',
  dispatched: 'పంపబడింది',
  dlqMonitor: 'DLQ మానిటర్',
  docChassisPlate: 'Chassis / Serial Plate Photo (RTO RC లేదు)',
  docEquipmentPhoto: 'Full Machine Photo (side view)',
  docIdentity: 'PAN Card / Aadhaar',
  docInsurance: 'Insurance Certificate',
  docInsuranceOptional: 'Insurance / Equipment Cover (if available)',
  docMachineInvoice: 'Machine Purchase / Invoice (dealer bill)',
  docPollution: 'Pollution Certificate (PUC)',
  docRcBook: 'RC Book (RTO Registration Certificate)',
  documentUploadTitle: 'పత్రాలు అప్‌లోడ్',
  documents: 'രേഖകൾ അപ്‌ലോഡ്',
  download: 'ഡൗൺലോഡ്',
  drawerMenu: 'మెనూ',
  earnings: 'വരുമാനം',
  email: 'ഇമെയിൽ പിന്തുണ',
  emailAddress: 'ഇമെയിൽ വിലാസം',
  emailAddressLabel: 'ఇమెయిల్ చిరునామా',
  expandBookingHint: 'పూర్తి బుకింగ్, రద్దు మరియు ఆపరేటర్ రేటింగ్ కోసం క్రింద నెల/రోజు విభాగాన్ని విస్తరించండి.',
  experience: 'പരിചയം',
  exportCsv: 'CSV ఎగsport',
  failedText: 'విఫలమైంది',
  feedbackAfterDispatch: 'మెషీన్ డిస్పాచ్ తర్వాత ఆపరేటర్ రేటింగ్ అందుబాటులో ఉంటుంది.',
  feedbackStatusAfterDispatch: 'డిస్పాచ్ తర్వాత',
  feedbackStatusRateNow: 'ఆపరేటర్‌ను రేట్ చేయండి ↓',
  filterAll: 'എല്ലാം',
  filterCredit: 'ക്രെഡിറ്റ്',
  filterDebit: 'ഡെബിറ്റ്',
  filterCompleted: 'പൂർത്തിയായി',
  filterCancelled: 'അടച്ചു',
  filterPending: 'തീർപ്പാക്കാത്തത്',
  filterDisputed: 'തർക്കം',
  forgotPasswordChooseMethod: 'పాస్‌వర్డ్ రీసెట్ కోసం ఇమెయిల్ లింక్ లేదా SMS OTP ఎంచుకోండి.',
  forgotPasswordEmailDevHint: 'Local dev: API server టర్మినల్ తెరిచి “Password reset link (development)” URL కాపీ చేయండి.',
  forgotPasswordEmailHint: 'నమోదైన అడ్మిన్ ఇమెయిల్ చిరునామా నమోదు చేయండి.',
  forgotPasswordFailed: 'రీసెట్ లింక్ పంపలేకపోయాము. మళ్లీ ప్రయత్నించండి.',
  forgotPasswordIntro: 'నమోదైన ఇమెయిల్ చిరునామాకు సురక్షిత రీసెట్ లింక్ పంపుతాము.',
  forgotPasswordInvalidEmail: 'చెల్లుబాటు అయ్యే ఇమెయిల్ చిరునామా నమోదు చేయండి.',
  forgotPasswordInvalidOtp: 'SMS నుండి 6 అంకెల OTP నమోదు చేయండి.',
  forgotPasswordInvalidPhone: 'చెల్లుబాటు అయ్యే 10 అంకెల మొబైల్ నంబర్ నమోదు చేయండి.',
  forgotPasswordLink: 'పాస్‌వర్డ్ మర్చిపోయారా?',
  forgotPasswordOtpSentTo: 'OTP పంపబడింది:',
  forgotPasswordPhoneHint: 'నమోదైన మొబైల్ నంబర్ నమోదు చేయండి. రీసెట్ లింక్ మీ ఖాతాలోని ఇమెయిల్‌కు వెళ్తుంది.',
  forgotPasswordSendOtp: 'OTP పంపండి',
  forgotPasswordSending: 'పంపుతోంది...',
  forgotPasswordSendingOtp: 'OTP పంపుతోంది...',
  forgotPasswordSmsDevHint: 'Productionలో SMS ఇంకా సెట్ కాలేదు — developmentలో OTP కోడ్ కోసం server logs చూడండి.',
  forgotPasswordSmsFailed: 'OTP పంపలేకపోయాము. మళ్లీ ప్రయత్నించండి.',
  forgotPasswordSmsHint: 'నమోదైన మొబైల్ నంబర్ నమోదు చేయండి. 6 అంకెల OTP SMS ద్వారా పంపబడుతుంది.',
  forgotPasswordSmsSuccess: 'ఖాతా ఉంటే, నమోదైన మొబైల్‌కు OTP పంపబడింది.',
  forgotPasswordSubmit: 'రీసెట్ లింక్ పంపండి',
  forgotPasswordSuccess: 'ఖాతా ఉంటే, నమోదైన ఇమెయిల్‌కు రీసెట్ సూచనలు పంపబడ్డాయి.',
  forgotPasswordTitle: 'మీ పాస్‌వర్డ్ రీసెట్ చేయండి',
  formLabel: 'ఫారం',
  fuel: 'ഇന്ധനം',
  fuelColon: 'ഇന്ധനം:',
  fuelHistoryTitle: 'ഇന്ധന ചരിത്രം',
  fuelLevel: 'ഇന്ധന നില',
  fuelLevelUpdate: 'ఇంధన స్థాయి అప్‌డేట్',
  fuelNotePlaceholder: 'കുറിപ്പ്: നിറച്ച / ഉപയോഗിച്ച ഇന്ധനം...',
  fullName: 'పూర్తి పేరు',
  goBook: '→ മെഷീൻ ബുക്ക് ചെയ്യൂ',
  gpsLiveLabel: '🟢 GPS లైవ్',
  grandTotal: 'മൊത്തം തുക',
  grandTotalText: 'మొత్తం మొత్తం',
  gross: 'స్థూల',
  grossBilling: 'മൊത്തം ബില്ലിംഗ്',
  gst18: 'GST (18%)',
  gstInvoice: 'GST ഇൻവോയ്സ്',
  gstInvoices: 'GST ఇన్వాయిస్‌లు',
  gstin: 'GSTIN',
  hide: 'దాచు',
  highTrend: 'HIGH Trend',
  hitsText: 'hits',
  hmrHrs: 'గం',
  hmrToday: 'ഇന്നത്തെ HMR',
  hmrTotal: 'ആകെ HMR',
  home: 'హోమ్',
  hours: 'മണിക്കൂർ',
  hrsUnit: 'മണി',
  idle: 'നിഷ്‌ക്രിയം',
  ifsc: 'IFSC',
  ignition: 'ഇഗ്നിഷൻ',
  importantInfo: 'മെഷീൻ ഉടമകൾക്ക് പ്രധാന വിവരം',
  instantCost: 'തൽക്ഷണ ചെലവ് കാൽക്കുലേറ്റർ',
  invoiceNotAvailableCancelled: 'ഇൻവോയ്സ് ലഭ്യമല്ല (റദ്ദാക്കി)',
  iot: 'IoT & GPS',
  issueReportTitle: 'సమస్య నివేదిక',
  issueReportedSuccess: 'సమస్య విజయవంతంగా నివేదించబడింది!',
  issues: 'సమస్యలు',
  joinUsAction: 'Join Us — ఉచిత నమోదు',
  joinUsBanner: 'మెషినరీ అద్దెకు కావాలా?',
  joinUsHint: 'కొత్త గ్రాహకుడు? JCB, excavator, crane బుక్ చేయడానికి ఉచితంగా నమోదు చేయండి.',
  landingCtaApp: 'Development Express అన్వేషించండి',
  landingFeatBook: 'నిమిషాల్లో బుకింగ్',
  landingFeatBookDesc: 'JCB, excavators, cranes — live availability & instant booking.',
  landingFeatPay: 'Wallet-only payments',
  landingFeatPayDesc: 'పారదర్శక బిల్లింగ్, GST invoices, నగదు గందరగోళం లేదు.',
  landingFeatTrack: 'Live GPS tracking',
  landingFeatTrackDesc: 'అద్దె ప్రతి గంట మీ మెషీన్ ఎక్కడ ఉందో తెలుసుకోండి.',
  landingHeroLine1: 'Smarter & Simpler.',
  landingHeroLine2: 'మహారాష్ట్ర మెషినరీ అద్దె — కొత్త రీతి.',
  landingSocialProof: 'మహారాష్ట్ర అంతటా బిల్డర్‌లు, కాంట్రాక్టర్‌లు & ఫ్లీట్ యజమానులు.',
  landingStatMachines: 'మెషీన్‌లు',
  landingStatRating: 'రేటింగ్',
  landingTrustLine: 'Wallet-only · GST compliant · Secured operations',
  lastRefreshed: 'చివరి రిఫ్రెష్',
  live: 'തൽസമയം',
  liveBookAvail: 'ബുക്കിംഗ് ശേഷം തൽസമയ ഫീഡ് ലഭ്യം',
  liveCamera: '360° തൽസമയ ക്യാമറ — ബുക്കിംഗ് ശേഷം',
  liveMachineLocation: 'ലൈവ് മെഷീൻ സ്ഥാനം',
  liveText: 'లైవ్',
  liveTracking: 'തൽസമയ ട്രാക്കിംഗ്',
  loadMoreAlerts: 'మరిన్ని హెచ్చరికలు లోడ్ చేయండి',
  loadMoreAttendance: 'మరిన్ని హాజరు లోడ్ చేయండి',
  loadMoreBookings: 'మరిన్ని బుకింగ్‌లు లోడ్ చేయండి',
  loadMoreDlq: 'మరిన్ని DLQ లోడ్ చేయండి',
  loadMoreFuelLogs: 'మరిన్ని ఇంధన లాగ్‌లు లోడ్ చేయండి',
  loadMoreLogs: 'మరిన్ని లాగ్‌లు లోడ్ చేయండి',
  loadMoreMachines: 'మరిన్ని మెషీన్‌లు లోడ్ చేయండి',
  loadMoreTransactions: 'మరిన్ని లావాదేవీలు లోడ్ చేయండి',
  loadMoreUsers: 'మరిన్ని వినియోగదారులు లోడ్ చేయండి',
  loadedBookings: 'లోడ్ చేసిన బుకింగ్‌లు',
  loadedDlqItems: 'లోడ్ చేసిన DLQ అంశాలు',
  loadedFuelLogs: 'లోడ్ చేసిన ఇంధన లాగ్‌లు',
  loadedOwnerBookings: '{count} ഉടമ ബുക്കിംഗ് ലോഡ്{suffix}',
  loading: 'లోడ్ అవుతోంది...',
  loadingDashboard: 'డాష్‌బోర్డ్ లోడ్ అవుతోంది...',
  location: 'സ്ഥാനം',
  lockConfirm: '🔒 ലോക്ക് സ്ഥിരീകരിക്കൂ',
  lockMachine: 'മെഷീൻ ലോക്ക് ചെയ്യൂ',
  lockWarning: 'Teltonika GPS വഴി മെഷീൻ ഇഗ്നിഷൻ വിദൂരമായി പ്രവർത്തനരഹിതമാക്കും.',
  locked: 'ലോക്ക്',
  loginAs: 'లాగిన్ అవుతున్నారు',
  loginChangeRole: 'పాత్ర మార్చండి',
  loginClientPortalSubtitle: 'నిర్మాణ మెషినరీ బుక్ చేయడానికి సైన్ ఇన్',
  loginEmailHint: 'అడ్మిన్ లాగిన్ కోసం నమోదైన ఇమెయిల్ ఉపయోగించండి.',
  loginFailedGeneric: 'లాగిన్ విఫలమైంది — దయచేసి మళ్లీ ప్రయత్నించండి',
  loginIAmQuestion: 'ഞാൻ ആരാണ്…?',
  loginModeOtp: 'OTP లాగిన్',
  loginModePassword: 'పాస్‌వర్డ్',
  loginNewHereRegister: 'కొత్తవారా? నమోదు',
  loginOtpDevHint: 'Development: SMS లేకపోతే API server log లో OTP చూడండి.',
  loginOtpHint: 'మీ నమోదైన మొబైల్ నంబర్‌కు 6 అంకెల OTP పంపబడుతుంది.',
  loginOtpSentTo: 'OTP పంపబడింది:',
  loginOwnerPortalSubtitle: 'ఫ్లీట్ & నమోదు నిర్వహించడానికి సైన్ ఇన్',
  loginPhoneHint: 'గ్రాహకుడు, యజమాని మరియు ఆపరేటర్ లాగిన్ కోసం నమోదైన మొబైల్ నంబర్ ఉపయోగించండి.',
  loginPickRoleHint: 'രജിസ്റ്റർ ചെയ്തവരാണോ? റോൾ തിരഞ്ഞെടുക്കൂ. പുതിയവരാണോ? താഴെ Join Us.',
  loginPortalAdminSubtitle: 'പ്ലാറ്റ്‌ഫോം നിയന്ത്രണവും അംഗീകാരവും',
  loginPortalAdminTitle: 'അഡ്മിൻ പോർട്ടൽ',
  loginPortalClientSubtitle: 'നിർമ്മാണ മെഷിനറി ബുക്ക് ചെയ്യാൻ സൈൻ ഇൻ',
  loginPortalClientTitle: 'ക്ലയന്റ് പോർട്ടൽ',
  loginPortalOperatorSubtitle: 'നിയോഗിച്ച മെഷീനുകൾക്കും ലോഗിനും സൈൻ ഇൻ',
  loginPortalOperatorTitle: 'ഓപ്പറേറ്റർ പോർട്ടൽ',
  loginPortalOwnerSubtitle: 'ഫ്ലീറ്റും രജിസ്ട്രേഷും നിയന്ത്രിക്കാൻ സൈൻ ഇൻ',
  loginPortalOwnerTitle: 'ഉടമ പോർട്ടൽ',
  loginRoleAdminDesc: 'പ്ലാറ്റ്‌ഫോം നിയന്ത്രണം, അംഗീകാരങ്ങൾ',
  loginRoleClientDesc: 'നിർമ്മാണ പ്രോജക്റ്റുകൾക്ക് മെഷിനറി ബുക്ക് ചെയ്യൂ',
  loginRoleClientShort: 'గ్రాహకుడు',
  loginRoleOperatorDesc: 'നിയോഗിച്ച മെഷീനുകളും ദൈനംദിന ലോഗും',
  loginRoleOwnerDesc: 'ഫ്ലീറ്റ്, വരുമാനം, ലഭ്യത നിയന്ത്രിക്കൂ',
  loginRoleOwnerShort: 'యజమాని',
  loginSendOtp: 'OTP పంపండి',
  loginSendingOtp: 'OTP పంపుతోంది...',
  loginSignInShort: 'సైన్ ఇన్',
  loginTabOtp: 'OTP',
  loginTabPassword: 'పాస్‌వర్డ్',
  loginVerifyOtp: 'Verify & Sign In',
  loginVerifyingOtp: 'Verify అవుతోంది...',
  logout: 'ലോഗ്ഔട്ട്',
  sessionRevokedAlert: 'നിങ്ങൾ മറ്റൊരു ഉപകരണത്തിൽ ലോഗിൻ ചെയ്തിട്ടുണ്ട്. ദയവായി വീണ്ടും ലോഗിൻ ചെയ്യുക.',
  machine: 'മെഷീൻ',
  machineDefaultLabel: 'മെഷീൻ',
  machineDetails: 'മെഷീൻ & ഓപ്പറേറ്റർ വിശദാംശങ്ങൾ',
  machineDetailsTitle: 'മെഷീൻ വിശദാംശങ്ങൾ',
  machineDispatchedAt: 'മെഷീൻ അയച്ചു — {when}',
  machineHours: 'మెషీన్ గంటలు',
  machineIdLabel: 'മെഷീൻ ID',
  machineInfo: 'മെഷീൻ വിവരങ്ങൾ',
  machineLabel: 'మెషీన్',
  machineLog: 'మెషీన్ లాగ్',
  machineReg: 'മെഷീൻ രജിസ്ട്രേഷൻ ഫോം',
  machineRegistrationSubmitted: 'మెషీన్ నమోదు సమర్పించబడింది! DE బృందం 24 గంటల్లో ధృవీకరిస్తుంది.',
  machineRegistrationTitle: 'మెషీన్ నమోదు',
  machineStatus: 'മെഷീൻ സ്ഥിതി',
  machineStatusTitle: 'మెషీన్ స్థితి',
  machines: 'മെഷീനുകൾ',
  marketingBackHome: 'వెబ్‌సైట్‌కు తిరిగి',
  marketingBadge: 'LIVE OPERATIONS · KARAD, SATARA',
  marketingBuiltFor: 'കൃത്യത, അനുസരണം, വേഗം വേണ്ട ഇന്ത്യൻ നിർമ്മാണ ടീമുകൾക്ക്.',
  marketingCtaBook: 'మెషీన్ బుక్ చేయండి',
  marketingCtaLogin: 'Development Express తెరవండి — Login',
  marketingCtaWhatsApp: 'WhatsApp చేయండి',
  marketingFooterRights: '2026 Development Express · Karad, Satara · All rights reserved',
  marketingHeadline: 'మహారాష్ట్రದ leading machinery rental platform',
  marketingLead: 'Real-time GPS tracking, digital wallet payments, and automated operations for construction machinery. Serving Maharashtra since 2011.',
  marketingNavContact: 'సంప్రదింపు',
  marketingNavLogin: 'ప్లాట్‌ఫామ్ లాగిన్ →',
  marketingNavServices: 'సేవలు',
  marketingNavTech: 'Technology',
  marketingServicesTitle: 'మేము ఏమి అందిస్తాము',
  marketingStatDigital: 'Digital payments',
  marketingStatFleet: 'Live machines',
  marketingStatYears: 'సంవత్సరాల అనుభవం',
  marketingSvcOps: 'Full operations stack',
  marketingSvcOpsSub: 'Owner, operator, and client — one platform.',
  marketingSvcPay: 'Wallet-only settlements',
  marketingSvcPaySub: 'GST-ready invoicing — no cash on site.',
  marketingSvcTrack: 'GPS & live status',
  marketingSvcTrackSub: 'Teltonika-linked fleet visibility for every booking.',
  marketingTechLead: 'Development Express ties bookings, compliance, and field telemetry into a single hardened workflow — from first enquiry to final invoice.',
  md: 'MD',
  mediumTrend: 'MEDIUM Trend',
  minAdvanceRequired: 'కనీస అడ్వాన్స్ అవసరం',
  minimumAdvance: 'ഏറ്റവും കുറഞ്ഞ അഡ്വാൻസ് ആവശ്യം',
  minimumRecharge: 'UPI/కార్డ్ కనీసం ₹1',
  moUnit: 'മാസം',
  mobileNumber: 'మొబైల్ నంబర్',
  monthMachineSummary: 'ఈ నెల మెషీన్‌లు',
  monthTotalLabel: 'నెల మొత్తం',
  months: 'മാസങ്ങൾ',
  moreAvailable: 'మరింత అందుబాటులో',
  myBookings: 'എന്റെ ബുക്കിംഗ്',
  myClientRating: 'నా గ్రాహకుడు రేటింగ్',
  myMachines: 'എന്റെ മെഷീനുകൾ',
  neftRtgs: 'NEFT/RTGS',
  netEarnedMonth: 'నికర ఆదాయం (నెల)',
  netPaid: 'నికర చెల్లింపు',
  netPayable: 'നെറ്റ് നൽകേണ്ടത്',
  netReceived: 'నికర అందుకున్న',
  netReceivedCaps: 'నికర అందుకున్న',
  neverText: 'ఎప్పుడూ లేదు',
  newBooking: 'కొత్త బుకింగ్',
  newClientRegister: 'కొత్త గ్రాహకుడు? ఇక్కడ నమోదు చేయండి',
  newClientRegistration: 'కొత్త గ్రాహకుడు నమోదు',
  newPassword: 'కొత్త పాస్‌వర్డ్',
  nextText: 'తదుపరి',
  noAlerts: 'അലർട്ടുകൾ ഇല്ല!',
  noAlertsNow: 'ഇപ്പോൾ അലർട്ടുകളില്ല.',
  noBankRefund: '❌ ബാങ്ക് റീഫണ്ട് ഇല്ല — വാലറ്റ് ക്രെഡിറ്റ് മാത്രം',
  noBookings: 'സജീവ ബുക്കിംഗ് ഇല്ല',
  noBookingsAccount: 'ഈ അക്കൗണ്ടിൽ ഇതുവരെ ബുക്കിംഗുകളില്ല.',
  noBookingsYet: 'ఇంకా బుకింగ్‌లు లేవు',
  noClientFeedbackYet: 'ఇంకా గ్రాహకుడు రేటింగ్‌లు లేవు. డిస్పాచ్ తర్వాత గ్రాహకుడు ఫీడ్‌బ్యాక్ ఇక్కడ కనిపిస్తుంది.',
  noDlqItems: 'DLQ అంశాలు లేవు',
  noFileSelected: 'ఫైల్ ఎంచుకోలేదు',
  noMachinesDashboard: 'ఇంకా మెషీన్‌లు లేవు. మీ ఫ్లీట్‌ను జోడించడానికి మెషీన్ నమోదు ఉపయోగించండి.',
  noMachinesTrack: 'ట్రాక్ చేయడానికి మెషీన్‌లు లేవు',
  noMachinesTrackHint: 'GPS ట్రాకింగ్ కోసం మెషీన్ నమోదు చేయండి.',
  noMachinesYet: 'ఇంకా మెషీన్‌లు నమోదు కాలేదు',
  noMoreAuditLogs: 'ప్రస్తుత ఫిల్టర్‌ల కోసం మరిన్ని ఆడిట్ లాగ్‌లు లేవు.',
  noRecentApiSloBreach: 'ఇటీవల API SLO breach సంకేతాలు లేవు.',
  noRecentFailedLogins: 'ఇటీవల విఫలమైన లాగిన్ ప్రయత్నాలు లేవు.',
  noRefund: 'റീഫണ്ട് ഇല്ല നയം',
  noSecuritySignalsFound: 'భద్రతా సంకేతాలు కనుగొనబడలేదు.',
  noTransactionsFilter: 'തിരഞ്ഞെടുത്ത ഫിൽട്ടറിന് ഇടപാടുകളില്ല.',
  normalText: 'సాధారణ',
  off: 'OFF',
  officeLabel: 'ఆఫీస్',
  on: 'ON',
  operator: 'ഓപ്പറേറ്റർ',
  operatorFeedbackColumn: 'ఆపరేటర్ ఫీడ్‌బ్యాక్',
  operatorFeedbackSaved: 'ధన్యవాదాలు! మీ ఫీడ్‌బ్యాక్ సేవ్ అయింది.',
  operatorFeedbackSubmitted: 'మీ ఫీడ్‌బ్యాక్',
  operatorFeedbackTitle: 'ఆపరేటర్ ఫీడ్‌బ్యాక్',
  operatorPortal: 'ఆపరేటర్ పోర్టల్',
  operatorRole: 'ഓപ്പറേറ്റർ',
  operatorSatisfactionQuestion: 'మీరు ఆపరేటర్‌తో సంతృప్తిగా ఉన్నారా?',
  operatorSuggestionPlaceholder: 'సూచన లేదా ఫీడ్‌బ్యాక్ (ఐచ్ఛికం)',
  operators: 'ഓപ്പറേറ്റർമാർ',
  optionalLabel: '(ఐచ్ఛికం)',
  otpCode: 'OTP కోడ్',
  overview: 'അവലോകനം',
  ownerBookingsAllLoaded: ' (എല്ലാം ലോഡ്)',
  ownerBookingsMoreAvailable: ' (കൂടുതൽ ലഭ്യം)',
  ownerInfo: 'ഉടമ വിവരങ്ങൾ',
  ownerPortal: 'యజమాని పోర్టల్',
  ownerRole: 'മെഷീൻ ഉടമ',
  owners: 'ഉടമകൾ',
  password: 'പാസ്‌വേഡ്',
  passwordsMustMatch: 'పాస్‌వర్డ్ మరియు నిర్ధారణ ఒకేలా ఉండాలి.',
  pastIssuesTitle: 'గత సమస్యలు',
  payNow: 'ഇപ്പോൾ പേ ചെയ്യൂ',
  payNowText: 'ఇప్పుడు చెల్లించండి',
  paymentBreakdownTitle: 'చెల్లింపు వివరాలు — April 2026',
  paymentCycle: 'చెల్లింపు చక్రం',
  paymentFailed: 'చెల్లింపు విఫలమైంది! దయచేసి మళ్లీ ప్రయత్నించండి.',
  paymentHistory: 'പേയ്‌മെന്റ് ചരിത്രം',
  paymentHistoryTitle: 'చెల్లింపు చరిత్ర',
  paymentMethods: 'പേയ്‌മെന്റ് രീതികൾ',
  paymentMode: 'చెల్లింపు విధానం',
  paymentSuccess: 'చెల్లింపు విజయవంతం!',
  pdfInvoiceFailed: 'ഇൻവോയ്സ് PDF തയ്യാറാക്കാനായില്ല. വീണ്ടും ശ്രമിക്കൂ.',
  pdfReportFailed: 'റിപ്പോർട്ട് PDF തയ്യാറാക്കാനായില്ല. വീണ്ടും ശ്രമിക്കൂ.',
  pdiCompleted: '✅ PDI / Safety inspection పూర్తయింది',
  pdiCrawlerHint: 'Crawler plant: pollution (PUC) అవసరం లేదు — మెషీన్ RTO రోడ్-registered కాదు.',
  pdiInfo: 'PDI പരിശോധന',
  pdiInsuranceApplicable: '✅ Insurance / cover (if applicable)',
  pdiInsuranceValid: '✅ Insurance valid & up to date',
  pdiPollutionValid: '✅ Pollution certificate (PUC) valid',
  pdiTitle: 'Pre-Delivery Inspection (PDI)',
  penaltyDeduct: 'റദ്ദാക്കൽ പിഴ (1 മണിക്കൂർ)',
  pending: 'పెండింగ్',
  pendingApproval: 'ఆమోదం పెండింగ్',
  pendingCount: '{count} തീർപ്പാക്കാത്തത്',
  pendingDispatch: 'డిస్పాచ్ పెండింగ్',
  perDay: 'ദിവസത്തിന്',
  perHour: 'മണിക്കൂറിന്',
  perMonth: 'മാസത്തിന്',
  perWeek: 'ആഴ്ചയ്ക്ക്',
  phone: 'ఫోన్',
  platform: 'നിർമ്മാണ മാനേജ്‌മെന്റ് പ്ലാറ്റ്‌ഫോം',
  platformAgreement: 'ప్లాట్‌ఫామ్ ఒప్పందం',
  policyLabel: 'നയം',
  policyTopicBooking: 'ബുക്കിംഗ്',
  policyTopicCancellation: 'റദ്ദാക്കൽ',
  policyTopicContact: 'ബന്ധം',
  policyTopicGst: 'GST',
  policyTopicHours: 'സപ്പോർട്ട് സമയം',
  portalBackLink: 'పోర్టల్',
  portalClient: 'గ్రాహకుడు',
  portalClientSub: 'మెషినరీ బుక్ చేయండి',
  portalNewClientRegister: 'కొత్త గ్రాహకుడు? నమోదు',
  portalNewOwnerRegister: 'కొత్త యజమాని? నమోదు',
  portalOwner: 'యజమాని',
  portalOwnerSub: 'ఫ్లీట్ నిర్వహణ',
  portalStaffAdmin: 'అడ్మిన్',
  portalStaffOperator: 'ఆపరేటర్',
  portalWelcome: 'స్వాగతం',
  portalWelcomeHint: 'కొనసాగడానికి మీ పోర్టల్ ఎంచుకోండి',
  quantityLabel: 'അളവ്',
  quickIssueReport: 'త్వరిత సమస్య నివేదిక',
  quickRechargeUpi: 'UPI വഴി പെട്ടെന്ന് റീചാർജ്',
  quickSelect: 'പെട്ടെന്ന് തിരഞ്ഞെടുക്കൂ:',
  rateCard: 'നിരക്ക് കാർഡ് (ഓപ്പറേറ്റർ ഉൾപ്പെടെ)',
  rateLimitTelemetryTitle: 'Rate Limit Telemetry',
  rateOperatorWork: 'ఆపరేటర్ పనిని రేట్ చేయండి (1–5 stars)',
  rating: 'റേറ്റിംഗ്',
  receiptId: 'రసీదు ID',
  recentAlerts: 'ఇటీవలి హెచ్చరికలు',
  recentFailedLoginsTitle: 'ఇటీవల విఫలమైన లాగిన్‌లు',
  recentLabel: 'അടുത്തിടെ',
  recharge: 'റീചാർജ്',
  rechargeFirst: '⚡ ആദ്യം വാലറ്റ് റീചാർജ് ചെയ്യൂ',
  rechargeWallet: '+ വാലറ്റ് റീചാർജ്',
  ref: 'റഫറൻസ് നം.',
  refreshText: 'రిఫ్రెష్',
  refreshingText: 'రిఫ్రెష్ అవుతోంది...',
  regCapacitySpecs: 'సామర్థ్యం / వివరాలు',
  regDocCrawlerHint: 'Crawler (excavator): chassis plate, machine purchase invoice, machine photo మరియు ID అవసరం. Insurance optional.',
  regDocWheeledHint: 'Wheeled: RC (RTO), insurance, PUC మరియు ID అవసరం (ప్రతి 5MB).',
  regEquipmentCategory: 'పరికర వర్గం *',
  regFailed: 'నమోదు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.',
  regFileSizeError: 'ప్రతి document 5MB లేదా తక్కువగా ఉండాలి',
  regFileTypeError: 'PDF, JPG, PNG లేదా WEBP ఫైళ్లు మాత్రమే అనుమతించబడతాయి',
  regFleetIdOptional: 'ఫ్లీట్ / chassis ID (ఐచ్ఛికం)',
  regMachineCategory: 'మెషీన్ వర్గం *',
  regMachineInfoTitle: 'మెషీన్ సమాచారం',
  regMachineIntro: 'నిర్మాణ heavy equipment మాత్రమే — ట్రక్/ట్రాన్స్‌పోర్ట్ లేదు. Wheeled plant (ఉదా. JCB 3DX) కు RTO; crawler plant (Poclain, dozer) సైట్-మాత్రమే — RTO passing లేదు.',
  regMachineNameModel: 'మెషీన్ పేరు / మోడల్',
  regMobilityTracked: 'Crawler',
  regMobilityTrackedHint: 'Poclain / chain excavator, dozer, crawler crane — సైట్ plant, RTO passing లేదు',
  regMobilityWheeled: 'Wheeled',
  regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — RTO (RC) ഉള്ള നിർമ്മാണ plant',
  machineFinancialSection: 'മെഷീൻ വാങ്ങൽ വിവരങ്ങൾ (ഓപ്ഷണൽ)',
  machineOwnershipType: 'ഉടമസ്ഥത തരം',
  machineOwnershipNew: 'പുതിയ മെഷീൻ',
  machineOwnershipUsed: 'യഥാർത്ഥ ഉടമ',
  machineOwnershipSecondHand: 'മുൻ-ഉടമസ്ഥത',
  machinePurchasePrice: 'വാങ്ങൽ വില (₹)',
  machinePurchasePriceHint: 'ഈ മെഷീനിന് നിങ്ങൾ അടച്ച തുക',
  machinePurchaseDate: 'വാങ്ങൽ തീയതി',
  machineYearOfManufacture: 'നിർമ്മാണ വർഷം',
  machineLoanSection: 'ഈ മെഷീനിൽ എനിക്ക് loan ഉണ്ട്',
  machineLoanAmount: 'Loan തുക (₹)',
  machineLoanEmi: 'പ്രതിമാസ EMI (₹)',
  machineLoanTenure: 'Loan കാലാവധി (മാസങ്ങൾ)',
  machineLoanStartDate: 'Loan ആരംഭ തീയതി',
  machineFuelConsumption: 'ഇന്ധന ഉപഭോഗം (L/hr)',
  machineMonthlyOperatingExpenses: 'മാസ ഓപ്പറേറ്റിംഗ് ചെലവുകൾ',
  machineOperatorMonthlySalary: 'ഓപ്പറേറ്റർ മാസ ശമ്പളം',
  machineServiceMonthly: 'സർവീസ് / അറ്റകുറ്റപ്പണി (മാസം)',
  machineBreakdownMonthly: 'ബ്രേക്ക്ഡൗൺ / അറ്റകുറ്റം (മാസ ശരാശരി)',
  machineMaterialsMonthly: 'സാമഗ്രികൾ / ഉപഭോഗ്യ വസ്തുക്കൾ (മാസം)',
  recoveryPlan: 'റിക്കവരി പ്ലാൻ',
  recoveryOnTrack: 'ശരിയായ പാതയില്',
  recoveryNeedsAttention: 'ശ്രദ്ധ ആവശ്യമാണ്',
  recoveryActionRequired: 'നടപടി ആവശ്യമാണ്',
  recoveryAddPrice: 'റിക്കവരി പ്ലാൻ കാണാൺ വാങ്ങല വില ചേര്ക്കുക',
  recoveryProgress: 'നിക്ഷേപം തിരിച്ചെടുത്ത',
  recoveryDailyNet: 'ദൈനംദിന അറ്റ വരുമാനം',
  recoveryDays: 'റിക്കവറി കാലാവധി',
  recoveryProjectedDate: 'പ്രതീക്ഷിത റിക്കവറി തീയതി',
  recoveryRoi: 'വാർഷിക വരുമാനം',
  recoveryCurrentValue: 'നിലവിലെ യന്ത്ര മൂല്യം',
  editFinancialDetails: 'സാമ്പത്തിക വിവരങ്ങൾ എഡിറ്റ് ചെയ്യുക',
  financialDetailsSaved: 'സാമ്പത്തിക വിവരങ്ങൾ സേവ് ചെയ്തു',
  recoveryBackfillNudge: 'റിക്കവറി ട്രാക്കിംഗ് അൺലോക്ക് ചെയ്യാൻ {{count}} മെഷിൻ(ങ്ങൾ)ക്ക് വാങ്ങൽ വിവരങ്ങൾ ചേർക്കുക',
  dieselPriceTitle: 'ഡീസൽ വില',
  dieselPriceUpdate: 'ഡീസൽ വില അപ്ഡേറ്റ് ചെയ്യുക',
  dieselPriceLatest: 'ഏറ്റവും പുതിയ വില',
  dieselPriceNoRecord: 'ഡീസൽ വില രേഖപ്പെടുത്തിയിട്ടില്ല',
  dieselPricePerLitre: 'ലിറ്റർ വില (₹)',
  dieselQuantity: 'നിറച്ച അളവ് (ലിറ്റർ)',
  dieselTaluka: 'നഗരം / പ്രദേശം',
  bookingAttachment: 'അറ്റാച്ച്‌മെന്റ് തിരഞ്ഞെടുക്കുക',
  bookingAttachmentNone: 'നിർദ്ദിഷ്ട അറ്റാച്ച്‌മെന്റ് ഇല്ല',
  bookingWorkDescription: 'ജോലി വിവരണം',
  bookingWorkDescriptionPlaceholder: 'ഉദാ. അടിത്തറ കുഴിക്കൽ, ട്രെഞ്ചിംഗ്, പൈപ്പ്‌ലൈൻ ജോലി',
  bookingAttachmentLabel: 'അറ്റാച്ച്‌മെന്റ്',
  bookingSiteLabel: 'സൈറ്റ്',
  bookingWorkLabel: 'ജോലി',
  termsAccept: "ഞാൻ നിബന്ധനകളും വ്യവസ്ഥകളും അംഗീകരിക്കുന്നു",
  termsRequired: "രജിസ്റ്റർ ചെയ്യാൻ നിബന്ധനകളും വ്യവസ്ഥകളും അംഗീകരിക്കണം",
  termsLink: "നിബന്ധനകളും വ്യവസ്ഥകളും",
  clientBlacklisted: "ബ്ലാക്ക്‌ലിസ്റ്റ്",
  clientBlacklistReason: "ബ്ലാക്ക്‌ലിസ്റ്റ് കാരണം",
  clientBlacklistConfirm: "ഈ ക്ലയന്റിനെ ബ്ലാക്ക്‌ലിസ്റ്റ് ചെയ്യണോ?",
  clientUnblacklist: "ബ്ലാക്ക്‌ലിസ്റ്റിൽ നിന്ന് നീക്കം ചെയ്യുക",
  blacklistedClients: "ബ്ലാക്ക്‌ലിസ്റ്റ് ക്ലയന്റുകൾ",
  blacklistedClientsEmpty: "ബ്ലാക്ക്‌ലിസ്റ്റ് ക്ലയന്റുകളില്ല",
  managerAccessRestricted: "ഫിനാൻസ് ആക്‌സസ് നിയന്ത്രിച്ചിരിക്കുന്നു. ഓം ചവാൻ ബന്ധപ്പെടുക.",
  managerSection: "മാനേജർമാർ",
  managerAdd: "മാനേജർ ചേർക്കുക",
  managerName: "മാനേജറുടെ പേര്",
  managerEmail: "മാനേജർ ഇമെയിൽ",
  managerPassword: "താൽക്കാലിക പാസ്‌വേഡ്",
  managerCreated: "മാനേജർ അക്കൗണ്ട് സൃഷ്ടിച്ചു",
  managerCredentialsTitle: "മാനേജർ ലോഗിൻ വിവരങ്ങൾ",
  managerCredentialsSubtitle: "ഈ വിവരങ്ങൾ ഇപ്പോൾ സൂക്ഷിക്കുക — പാസ്‌വേഡ് പിന്നീട് തിരിച്ചുകിട്ടില്ല",
  managerCredentialsSaved: "ഞാൻ വിവരങ്ങൾ സൂക്ഷിച്ചു",
  managerLoginUrl: "ലോഗിൻ URL",
  managerActivity: "മാനേജർ പ്രവർത്തനം",
  managerActivityEmpty: "ഇതുവരെ പ്രവർത്തനമൊന്നും രേഖപ്പെടുത്തിയിട്ടില്ല",
  managerActivityViewAll: "എല്ലാ പ്രവർത്തനവും കാണുക",
  onboardingTitle: "ആരംഭിക്കുക",
  onboardingAccountApproved: "അക്കൗണ്ട് അംഗീകരിച്ചു",
  onboardingKycComplete: "KYC പരിശോധന പൂർത്തിയായി",
  onboardingKycPending: "KYC പരിശോധന പൂർത്തിയാക്കുക",
  onboardingKycRejected: "KYC നിരസിച്ചു — വീണ്ടും സമർപ്പിക്കുക",
  onboardingWalletFunded: "വാലറ്റിൽ ബാലൻസ് ഉണ്ട്",
  onboardingWalletEmpty: "ബുക്കിംഗിന് വാലറ്റ് ബാലൻസ് ചേർക്കുക",
  pushEnablePrompt: "തൽക്ഷണ അപ്ഡേറ്റുകൾക്ക് പുഷ് അറിയിപ്പുകൾ ഓണാക്കൂ",
  downloadDisputeStatement: "തർക്ക പ്രസ്താവന ഡൗൺലോഡ് ചെയ്യുക",
  downloadInvoice: "ഇൻവോയ്സ് ഡൗൺലോഡ് ചെയ്യുക",
  bookAgain: "വീണ്ടും ബുക്ക് ചെയ്യുക",
  machineNoLongerAvailable: "മെഷീൻ ഇപ്പോൾ ലഭ്യമല്ല",
  downloadHistoryPdf: "ചരിത്രം PDF ഡൗൺലോഡ് ചെയ്യുക",
  onboardingFirstBooking: "നിങ്ങളുടെ ആദ്യ ബുക്കിംഗ് ചെയ്യുക",
  onboardingAllDone: "നിങ്ങൾ തയ്യാറാണ്!",
  onboardingTrackerTitle: "ഓൺബോർഡിംഗ് പുരോഗതി",
  onboardingTrackerTarget: "ഓൺബോർഡിംഗ് ലക്ഷ്യം: 48 മണിക്കൂർ",
  onboardingTrackerInProgress: "പുരോഗതിയിൽ",
  onboardingTrackerActionRequired: "നടപടി ആവശ്യം",
  onboardingTrackerComplete: "പൂർത്തിയായി",
  onboardingTrackerPending: "തീർപ്പാക്കാത്തത്",
  onboardingTrackerPhase1: "രജിസ്ട്രേഷൻ",
  onboardingTrackerPhase2: "KYC പരിശോധന",
  onboardingTrackerPhase3: "മെഷീൻ രജിസ്ട്രേഷൻ",
  onboardingTrackerPhase4: "ആദ്യ ബുക്കിംഗ് തയ്യാർ",
  onboardingTrackerHelper1: "മെഷീൻ രജിസ്ട്രേഷൻ തുറക്കാൻ ആധാർ + സെൽഫി അപ്‌ലോഡ് ചെയ്യുക",
  onboardingTrackerHelper2: "KYC അവലോകനത്തിൽ — സാധാരണയായി 24 മണിക്കൂറിനുള്ളിൽ",
  onboardingTrackerHelper3: "KYC നിരസിച്ചു — രേഖകൾ വീണ്ടും സമർപ്പിക്കുക",
  onboardingTrackerHelper4: "KYC അംഗീകരിച്ചു — നിങ്ങളുടെ ആദ്യ മെഷീൻ ചേർക്കുക",
  onboardingTrackerHelper5: "മെഷീൻ അഡ്‌മിൻ അവലോകനത്തിൽ",
  onboardingTrackerHelper6: "മെഷീൻ ലൈവ് — ആദ്യ ബുക്കിംഗിനായി കാത്തിരിക്കുന്നു",
  onboardingTrackerPhaseLabel: "ഘട്ടം",
  alertsAndNotifications: 'അലർട്ടുകളും അറിയിപ്പുകളും',
  dieselFuelCostPerHour: 'മണിക്കൂർ ഇന്ധന ചെലവ്',
  dieselPercentOfRate: 'നിങ്ങളുടെ മണിക്കൂർ നിരക്കിന്റെ',
  dieselPriceSaved: 'ഡീസൽ വില സേവ് ചെയ്തു',
  dieselRateSuggestion: 'നിരക്ക് നിർദ്ദേശം',
  dieselRateIncrease: 'ഡീസൽ ഉയർന്നു — നിരക്ക് ഉയർത്താൻ പരിഗണിക്കുക',
  dieselRateDecrease: 'ഡീസൽ കുറഞ്ഞു — ബുക്കിംഗിനായി നിരക്ക് കുറയ്ക്കുക',
  dieselSuggestedRate: 'നിർദ്ദേശിച്ച നിരക്ക്',
  dieselHistory: 'വില ചരിത്രം',
  dieselNoHistory: 'ഡീസൽ വില ചരിത്രം ഇതുവരെയില്ല',
  dieselColDate: 'തീയതി',
  dieselColPrice: 'വില/ലിറ്റർ',
  dieselColQty: 'അളവ്',
  dieselColSource: 'ഉറവിടം',
  dieselUploadReceipt: 'രസീത് അപ്‌ലോഡ്',
  dieselExtractSuccess: 'രസീതിൽ നിന്ന് എടുത്തു',
  dieselExtractFailed: 'എടുക്കാൻ കഴിഞ്ഞില്ല — സ്വമേധയാ നൽകുക',
  applyRateSuggestion: '₹{{rate}}/മണിക്കൂർ പ്രയോഗിക്കുക',
  rateSuggestionApplied: 'നിരക്ക് വിജയകരമായി അപ്‌ഡേറ്റ് ചെയ്തു',
  marketPosition: 'മാർക്കറ്റ് സ്ഥാനം',
  marketBelowMarket: 'മാർക്കറ്റിനേക്കാൾ കുറവ്',
  marketCompetitive: 'മത്സരാധിഷ്ഠിത',
  marketAboveMarket: 'മാർക്കറ്റിനേക്കാൾ കൂടുതൽ',
  marketNoData: 'നിങ്ങളുടെ പ്രദേശത്തിന് ഇതുവരെ മാർക്കറ്റ് ഡാറ്റയില്ല',
  marketSubmitRate: 'മാർക്കറ്റ് നിരക്ക് സമർപ്പിക്കുക',
  marketCity: 'നഗരം / പ്രദേശം',
  marketMinRate: 'നിങ്ങളുടെ പ്രദേശത്തെ കുറഞ്ഞ നിരക്ക് (₹/മണിക്കൂർ)',
  marketMaxRate: 'നിങ്ങളുടെ പ്രദേശത്തെ ഉയർന്ന നിരക്ക് (₹/മണിക്കൂർ)',
  marketRateSubmitted: 'മാർക്കറ്റ് നിരക്ക് സമർപ്പിച്ചു — നന്ദി!',
  marketDataPoints: '{{count}} സമർപ്പണ(ങ്ങൾ) അടിസ്ഥാനത്തിൽ',
  marketRange: '{{city}} ലെ മാർക്കറ്റ്',
  marketSourceLocal: '{{city}} പ്രദേശ നിരക്കുകളെ അടിസ്ഥാനമാക്കി',
  marketSourcePlatform: 'പ്ലാറ്റ്ഫോം-വ്യാപക നിരക്കുകളെ അടിസ്ഥാനമാക്കി',
  regPremiumOnboarding: 'Premium onboarding',
  regRtoNumber: 'RTO నమోదు నంబర్ *',
  regSelectType: 'రకం ఎంచుకోండి…',
  regSubmitBtn: '✅ నమోదు సమర్పించండి',
  regTagNoRto: 'RTO లేదు',
  regTagRto: 'RTO',
  regYearManufacture: 'తయారీ సంవత్సరం *',
  register: 'മെഷീൻ രജിസ്ട്രേഷൻ',
  registerAction: 'నమోదు చేయండి',
  registerMachine: 'మెషీన్ నమోదు',
  registering: 'నమోదు అవుతోంది...',
  registrationPending: 'అడ్మిన్ 24 గంటల్లో మీ అకౌంట్‌ను సక్రియం చేస్తారు.',
  registrationSuccess: 'నమోదు విజయవంతం!',
  remoteLockAlert: 'Teltonika GPS device ఈ మెషీన్‌పై స్థాపించిన తర్వాత remote lock enable అవుతుంది. DE support ను సంప్రదించండి.',
  remoteLockMachine: '🔒 రిమోట్ లాక్ మెషీన్',
  replaceFile: 'మార్చు',
  reportText: 'నివేదిక',
  reports: 'റിപ്പോർട്ടുകൾ',
  resetMethodEmail: 'ఇమెయిల్ లింక్',
  resetMethodSms: 'SMS OTP',
  resetPasswordFailed: 'పాస్‌వర్డ్ రీసెట్ చేయలేకపోయాము. కొత్త లింక్ అభ్యర్థించండి.',
  resetPasswordIntro: 'కనీసం 8 అక్షరాల బలమైన పాస్‌వర్డ్ ఎంచుకోండి.',
  resetPasswordMinLength: 'పాస్‌వర్డ్ కనీసం 8 అక్షరాలు ఉండాలి.',
  resetPasswordMissingToken: 'రీసెట్ లింక్ లేదు లేదా చెల్లదు. లాగిన్ నుండి Forgot password వాడండి.',
  resetPasswordSubmit: 'పాస్‌వర్డ్ అప్‌డేట్ చేయండి',
  resetPasswordSuccess: 'పాస్‌వర్డ్ అప్‌డేట్ అయింది. లాగిన్‌కు మళ్లిస్తోంది...',
  resetPasswordTitle: 'కొత్త పాస్‌వర్డ్ సెట్ చేయండి',
  resetPasswordUpdating: 'అప్‌డేట్ అవుతోంది...',
  resetText: 'రీసెట్',
  retryDlqItemTitle: 'DLQ అంశం మళ్లీ ప్రయత్నించండి',
  retryFailedForDlq: 'DLQ అంశం కోసం మళ్లీ ప్రయత్నం విఫలమైంది',
  retryReasonAuditPlaceholder: 'మళ్లీ ప్రయత్నం కారణం (ఆడిట్ కోసం)',
  retryText: 'మళ్లీ ప్రయత్నించండి',
  revenue: 'ఆదాయం',
  running: 'నడుస్తోంది',
  satisfiedNo: 'సంతృప్తి లేదు',
  satisfiedYes: 'అవును, సంతృప్తి',
  save: 'സേവ് ചെയ്യൂ',
  scanToPay: 'പേയ്‌മെന്റിന് സ്കാൻ ചെയ്യൂ',
  scheduleColFeedback: 'ఫీడ్‌బ్యాక్',
  scheduleColQty: 'Qty',
  scheduleColTotal: 'మొత్తం',
  scheduleColType: 'రకం',
  securitySignalsTitle: 'భద్రతా సంకేతాలు',
  selectBook: 'ഈ മെഷീൻ ബുക്ക് ചെയ്യൂ →',
  selectCalc: '📋 തിരഞ്ഞെടുക്കൂ & ചെലവ് കാണൂ →',
  selectFile: 'ഫയൽ തിരഞ്ഞെടുക്കൂ',
  selectMachineFirst: 'ആദ്യം മെഷീൻ തിരഞ്ഞെടുക്കൂ',
  selectQty: 'അളവ് തിരഞ്ഞെടുക്കൂ',
  selectRole: 'റോൾ തിരഞ്ഞെടുക്കൂ',
  selectedMachineText: 'ఎంచుకున్న మెషీన్',
  send: 'അയയ്ക്കൂ',
  sendEmail: 'ഇമെയിൽ അയയ്ക്കൂ',
  sendWhatsapp: 'WhatsApp-ൽ അയയ്ക്കൂ',
  settlements: 'నిష్కర్ష',
  show: 'చూపించు',
  signIn: 'സൈൻ ഇൻ ചെയ്യൂ',
  signingIn: 'ലോഗിൻ ആകുന്നു...',
  signupCompanyName: 'കമ്പനി പേര്',
  signupContactName: 'ബന്ധപ്പെടാനുള്ള പേര്',
  signupCreatePassword: 'പാസ്‌വേഡ് സൃഷ്ടിക്കൂ',
  signupReenterPassword: 'പാസ്‌വേഡ് വീണ്ടും നൽകൂ',
  signupSectionCompany: 'കമ്പനി',
  signupSectionContact: 'നിങ്ങളുടെ വിവരങ്ങൾ',
  signupSectionSecurity: 'സുരക്ഷ',
  sinceExcellence: '2011 నుండి · 15 సం. శ్రేష్ఠత',
  sinceLabel: 'മുതൽ',
  sloBreachRisk: 'SLO BREACH RISK',
  sloHealthy: 'SLO HEALTHY',
  speed: 'വേഗത',
  staleText: 'పాతది',
  status: 'സ്ഥിതി',
  statusCancelled: 'റദ്ദാക്കി',
  bookingClosed: 'അടച്ചു',
  sectionNew: 'പുതിയത്',
  sectionAccepted: 'അംഗീകരിച്ചു',
  sectionActive: 'സജീവം',
  sectionDispatched: 'ഡിസ്പാച്ച്',
  sectionCompleting: 'പൂർത്തിയാക്കുന്നു',
  sectionDisputed: 'തർക്കം',
  sectionCompleted: 'പൂർത്തിയായി',
  sectionClosed: 'അടച്ചു',
  statusCompleted: 'പൂർത്തിയായി',
  stopped: 'ఆగింది',
  submit: 'സമർപ്പിക്കൂ',
  submitOperatorFeedback: 'ఫీడ్‌బ్యాక్ సమర్పించండి',
  submittedRegistrations: 'సమర్పించిన నమోదులు',
  support: 'പിന്തുണ',
  supportPolicyBooking: 'വാലറ്റ്-മാത്രം അഡ്വാൻസ്. സൈറ്റിൽ പണം ഇല്ല.',
  supportPolicyCancellation: '1 മണി പിഴ; ബാക്കി വാലറ്റിൽ.',
  supportPolicyContact: 'DE Support മാത്രം — നേരിട്ട് ഓപ്പറേറ്റർ ബന്ധം നിരോധിച്ചിരിക്കുന്നു.',
  supportPolicyGst: 'എല്ലാ ഇൻവോയ്സിലും 18% GST; Reports ടാബിൽ നിന്ന് ഡൗൺലോഡ്.',
  supportPolicyHours: 'തിങ്ക–ശനി, 9–7 IST',
  tableAtt: 'Att',
  tableChange: 'మార్పు',
  tableDay: 'రోజు',
  tableEnd: 'ముగింపు',
  tableHrs: 'గం',
  tableId: 'ID',
  tableIn: 'In',
  tableLevel: 'స్థాయి',
  tableMonth: 'నెల',
  tableNote: 'నోట్',
  tableOut: 'Out',
  tableStart: 'ప్రారంభం',
  tagline: 'അടിസ്ഥാന സൗകര്യത്തിന്റെ സ്വർണ്ണ നിലവാരം',
  tax: 'നികുതി',
  tdsGstTcs: 'TDS 2% + GST TCS 1%',
  tdsTcs: 'TDS+TCS',
  termCommission: 'Development Express కమీషన్: స్థూల బిల్లింగ్ యొక్క 15%',
  termFuel: 'మెషీన్‌లో ఎప్పుడూ 40%+ ఇంధనం ఉండాలి',
  termGps: 'GPS device (Teltonika) తప్పనిసరి — DE ద్వారా స్థాపించబడుతుంది',
  termGstTcs: 'GST TCS: GST regulations ప్రకారం 1%',
  termNoDirectContact: 'ప్రత్యక్ష గ్రాహకుడు సంప్రదింపు = వెంటనే contract termination',
  termPaymentDays: 'గ్రాహకుడు settlement తర్వాత 3 పని దినాల్లో చెల్లింపు',
  termTds: 'TDS deduction: Income Tax Act ప్రకారం 2%',
  threeWorkingDays: '3 పని దినాలు',
  timeLabel: 'സമയം',
  todayText: 'ఈరోజు',
  topSourceIp: 'టాప్ సోర్స్ IP',
  total: 'ആകെ',
  totalAdvanceLabel: 'అడ్వాన్స్ చెల్లించబడింది',
  totalBookingsText: 'మొత్తం బుకింగ్‌లు',
  totalMachines: 'ആകെ മെഷീനുകൾ',
  totalSpent: 'మొత్తం ఖర్చు',
  tracking: 'GPS ട്രാക്കിംഗ്',
  transactionHistoryTitle: 'లావాదేవీ చరిత్ర',
  transactions: 'ഇടപാട് ചരിത്രം',
  trustStatCompliant: 'അനുസരണ',
  trustStatMachines: 'മെഷീനുകൾ',
  trustStatRating: 'റേറ്റിംഗ്',
  txnDescription: 'വിവരണം',
  type: 'തരം',
  understood: '✅ മനസ്സിലായി — പ്ലാറ്റ്‌ഫോം ഉപയോഗിക്കും',
  understoodAction: 'అర్థమైంది',
  unknownText: 'తెలియదు',
  updateFuel: 'ఇంధనం అప్‌డేట్',
  updateText: 'అప్‌డేట్',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  uploadFile: 'అప్‌లోడ్',
  valEmail: 'చెల్లుబాటు అయ్యే ఇమెయిల్ అవసరం',
  valMachineName: 'మెషీన్ పేరు / model అవసరం',
  valMachineType: 'దయచేసి equipment category ఎంచుకోండి',
  valMobility: 'దయచేసి wheeled లేదా crawler equipment రకం ఎంచుకోండి',
  valOwnerName: 'యజమాని పేరు అవసరం',
  valPdiChecks: 'దయచేసి అన్ని required checks confirm చేయండి',
  valPdiRequired: 'PDI confirmation అవసరం',
  valPhone: 'చెల్లుబాటు అయ్యే ఫోన్ నంబర్ అవసరం',
  valRto: 'Wheeled machines కోసం RTO registration number అవసరం',
  valUploadMissing: 'దయచేసి upload చేయండి: {docs}',
  valYear: 'చెల్లుబాటు అయ్యే year (YYYY) అవసరం',
  viewMachines: '→ മെഷീനുകൾ കാണൂ',
  wallet: 'വാലറ്റ്',
  walletBalance: 'വാലറ്റ് ബാലൻസ്',
  walletCredit: 'വാലറ്റ് ക്രെഡിറ്റ്',
  walletDebit: 'വാലറ്റ് ഡെബിറ്റ്',
  walletDeduct: 'അഡ്വാൻസ് വാലറ്റിൽ നിന്ന് കുറയ്ക്കും · പണം ഇല്ല · GST സ്വയം സൃഷ്ടിക്കും',
  walletInsufficient: '❌ അപര്യാപ്തം',
  walletLowRecharge: 'വാലറ്റ് ബാലൻസ് കുറവ് — അടുത്ത ബുക്കിംഗിന് മുമ്പ് റീചാർജ് ചെയ്യൂ',
  walletOnly: 'വാലറ്റ് മാത്രം · പണം സ്വീകരിക്കില്ല',
  walletOnlyPolicyDesc: 'అన్ని లావాదేవీలు వాలెట్ ద్వారా మాత్రమే. నగదు అంగీకరించబడదు.',
  walletOnlyPolicyTitle: 'వాలెట్-మాత్రమే విధానం',
  walletRechargeTitle: 'వాలెట్ రీఛార్జ్',
  walletSufficient: '✅ തുടരൂ',
  weeks: 'ആഴ്ചകൾ',
  whatsapp: 'WhatsApp',
  wksUnit: 'ആഴ്ച',
  year: 'വർഷം',
  yearsExperience: '{n} വർഷം',
  yourMessage: 'നിങ്ങളുടെ ചോദ്യം അല്ലെങ്കിൽ പ്രശ്നം എഴുതൂ...',
  // --- Recent feature strings ---
  retryLabel: 'വീണ്ടും ശ്രമിക്കുക',
  payrollPreview: 'ശമ്പള പ്രിവ്യൂ',
  payrollRun: 'ശമ്പളം റൺ ചെയ്യുക',
  payrollAlreadyRun: 'ഈ മാസത്തേക്ക് ശമ്പളം ഇതിനകം റൺ ചെയ്തു',
  payrollGross: 'ആകെ നൽകേണ്ടത്',
  payrollNet: 'നെറ്റ് നൽകേണ്ടത്',
  payrollAdvanceDeducted: 'അഡ്വാൻസ് കിഴിവ്',
  payrollRunSuccess: 'ശമ്പളം വിജയകരമായി റൺ ചെയ്തു',
  payrollNoAmount: 'ഈ മാസത്തേക്ക് നൽകേണ്ട തുകയില്ല',
  payrollMonth: 'ശമ്പള മാസം',
  exportPayrollCsv: 'ശമ്പള CSV എക്സ്പോർട്ട്',
  payrollExportMonth: 'ശമ്പള എക്സ്പോർട്ട് മാസം',
  payrollDailyRate: 'ദൈനംദിന നിരക്ക്',
  payrollHistory: 'ശമ്പള ചരിത്രം',
  payrollNoHistory: 'ഇതുവരെ ശമ്പളം റൺ ചെയ്തിട്ടില്ല',
  payrollColMonth: 'മാസം',
  payrollColGross: 'ആകെ',
  payrollColDeduction: 'മുൻകൂട്ടി കിഴിവ്',
  payrollColNet: 'നെറ്റ് ശമ്പളം',
  payrollColDate: 'തീയതി',
  downloadPayslip: 'പേ സ്ലിപ്പ് ഡൗൺലോഡ്',
  payslipTitle: 'മാസിക പേ സ്ലിപ്പ്',
  payslipEarnings: 'വരുമാനം',
  payslipDeductions: 'കിഴിവുകൾ',
  payslipDaysWorked: 'ജോലി ദിവസങ്ങൾ',
  payslipGeneratedBy: 'Development Express നൽകിയത്',
  operatorPayrollTitle: 'എന്റെ ശമ്പളം',
  payrollMonthlySalary: 'മാസ ശമ്പളം',
  payrollCurrentMonth: 'നിലവിലെ മാസം',
  payrollPreviousMonth: 'കഴിഞ്ഞ മാസം',
  ownerAttendanceTitle: 'ഹാജർ',
  ownerAttendanceEdit: 'എഡിറ്റ്',
  ownerAttendanceSave: 'സേവ്',
  ownerAttendanceNoRecords: 'ഈ മാസത്തേക്ക് ഹാജർ രേഖകളില്ല',
  ownerAttendanceOverrideSuccess: 'ഹാജർ അപ്ഡേറ്റ് ചെയ്തു',
  ownerSalaryUpdated: 'ശമ്പളം വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു',
  ownerSalaryEditBtn: 'ശമ്പളം എഡിറ്റ്',
  ownerSalaryNotSet: 'ശമ്പളം സെറ്റ് ചെയ്തിട്ടില്ല — പേറോൾ ചെയ്യാൻ ശമ്പളം സെറ്റ് ചെയ്യുക',
  duration: "ദൈർഘ്യം",
  durationLabel: 'കാലാവധി',
  plQuotaLabel: 'PL ക്വോട്ട',
  plUsed: 'ഉപയോഗിച്ചു',
  plAllowed: 'അനുവദിച്ചു',
  plRemaining: 'ശേഷിക്കുന്ന',
  plQuotaUpdated: 'PL ക്വോട്ട അപ്ഡേറ്റ്',
  plQuotaExhausted: 'PL ക്വോട്ട തീർന്നു — ശമ്പളമില്ലാത്ത അവധിയായി രേഖപ്പെടുത്തി',
  plRemainingLabel: 'ശേഷിക്കുന്ന PL',
  noAttendanceRecords: 'ഇതുവരെ ഹാജരാത്ത രേഖകൾ ഇല്ല',
  noFuelLogs: 'ഇതുവരെ ഇന്ധന ലോഗുകൾ ഇല്ല',
  noIssuesYet: 'ഇതുവരെ ഒരു പ്രശ്നവും രേഖപ്പെടുത്തിയിട്ടില്ല',
  failedToLoad: 'ഡാറ്റ ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു',
  failedToLoadReport: 'റിപ്പോർട്ട് ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു',
  failedToLoadIssues: 'പ്രശ്നങ്ങൾ ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു',
  failedToLoadAlerts: 'അലേർട്ടുകൾ ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു',
  noRecordsMonth: 'ഈ മാസത്തിൽ രേഖകൾ ഇല്ല',
  underReview: 'പരിശോധനയിലാണ്',
  issueResolved: 'പരിഹരിച്ചു',
  presentDaysLabel: 'ഹാജർ ദിവസങ്ങൾ',
  halfDaysLabel: 'അർധ ദിവസങ്ങൾ',
  absentDaysLabel: 'അനുപസ്ഥിത ദിവസങ്ങൾ',
  totalHmrLabel: 'ആകെ HMR',
  noActiveBookingIdle: 'സജീവ ബുക്കിംഗ് ഇല്ല — മെഷീൻ നിഷ്ക്രിയം',
  siteLocationNotCaptured: 'സൈറ്റ് സ്ഥാനം രേഖപ്പെടുത്തിയിട്ടില്ല',
  siteLocationNotAvailable: 'സൈറ്റ് സ്ഥാനം ലഭ്യമല്ല',
  bookingRefLabel: 'ബുക്കിംഗ് Ref',
  alertPendingBookings: 'തീർപ്പാക്കാത്ത ബുക്കിംഗുകൾ',
  alertPendingPayouts: 'തീർപ്പാക്കാത്ത പെയ്‌മെന്റുകൾ',
  alertLowFuel: 'കുറഞ്ഞ ഇന്ധനം',
  alertOpenIssues: 'തുറന്ന പ്രശ്നങ്ങൾ',
  noMachineRunning: 'നിലവിൽ ഒരു മെഷീനും പ്രവർത്തിക്കുന്നില്ല',
  trackingEmptyHint: 'മെഷീൻ അയച്ചുകഴിഞ്ഞാൽ നിങ്ങളുടെ സജീവ ബുക്കിംഗ് ഇവിടെ കാണാം.',
  trackingUpdatedEvery5s: 'ഓരോ 5 സെക്കന്റിലും പുതുക്കുന്നു',
  fuelLastOperatorUpdate: '(ഓപ്പറേറ്റർ അപ്ഡേറ്റ്)',
  alertExtensionPending: 'ബുക്കിംഗ് എക്സ്റ്റൻഷൻ തീർപ്പാക്കാത്തത്',
  alertConfirmCompletion: 'ജോലി പൂർത്തീകരണം സ്ഥിരീകരിക്കുക',
  alertWalletCredited: 'വാലറ്റിൽ ചേർത്തു',
  alertFeedbackRequest: 'ജോലി പൂർത്തം — നിങ്ങളുടെ അഭിപ്രായം പങ്കിടുക',
  noLogsYet: 'ഇതുവരെ പ്രവർത്തനം രേഖപ്പെടുത്തിയിട്ടില്ല',
  todayActivityLog: 'ഇന്നത്തെ പ്രവർത്തന ലോഗ്',
  machineLogSubtitle: 'ഇന്ധനം, ഹാജർ, പ്രശ്നങ്ങൾ — പ്രാദേശിക സെഷൻ ലോഗ്',
  timerPaused: 'Timer നിർത്തിവച്ചു',
  liveBookingTitle: 'ലൈവ് ബുക്കിംഗ്',
  machineLogTimerHint: 'Timer Admin ആരംഭിക്കുന്നു. താഴെ നിങ്ങളുടെ യഥാർത്ഥ ജോലി സമയം രേഖപ്പെടുത്തുക — പൂർത്തിയായാൽ Mark Work Complete ക്ലിക്ക് ചെയ്യുക.',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'ഹാജർ',
  ownerAlertBookingPending: 'പുതിയ ബുക്കിംഗ് നിങ്ങളുടെ അനുമതിക്കായി തീർപ്പാക്കാത്തത് —',
  ownerAlertBookingHours: 'മണിക്കൂർ',
  ownerAlertPayoutPending: '₹{{amount}} പേയ്‌മെന്റ് ട്രാൻസ്ഫറിനായി തീർപ്പാക്കാത്തത്',
  ownerAlertFuelLow: 'ഇന്ധനം കുറവ്',
  ownerAlertFuelRemaining: 'ശേഷിക്കുന്നു',
  ownerAlertIssue: 'പ്രശ്നം രേഖപ്പെടുത്തി',
  iotGpsDevicesActive: 'GPS ഉപകരണങ്ങൾ സജീവം',
  iotDashcamsOnline: 'ഡാഷ്‌കാമുകൾ ഓൺലൈൻ',
  iotFuelSensorsActive: 'ഇന്ധന സെൻസറുകൾ സജീവം',
  iotMachinesLocked: 'മെഷീനുകൾ ലോക്ക്',
  iotDeviceStatus: 'IoT ഉപകരണ നില',
  iotColMachine: 'മെഷീൻ',
  iotColGps: 'GPS',
  iotColLocation: 'സ്ഥലം',
  iotColFuel: 'ഇന്ധന %',
  iotColDashcam: 'ഡാഷ്‌കാം',
  iotColIgnition: 'ഇഗ്നിഷൻ',
  iotColAction: 'നടപടി',
  iotStatusOnline: 'ഓൺലൈൻ',
  iotStatusNotConnected: 'ബന്ധിപ്പിച്ചിട്ടില്ല',
  iotStatusLive: 'ലൈവ്',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'ലോക്ക്',
  iotNotConnectedBanner: 'IoT ഹാർഡ്‌വെയർ ഇതുവരെ ഇൻസ്റ്റാൾ ചെയ്തിട്ടില്ല. Teltonika ഉപകരണം ഇൻസ്റ്റാൾ ചെയ്തതിന് ശേഷം GPS, ഡാഷ്‌കാം, റിമോട്ട് ലോക്ക് സൗകര്യങ്ങൾ ലഭ്യമാകും.',
  fuelUpdateTitle: 'ഇന്ധന അപ്ഡേറ്റ്',
  fuelSensorAccuracyNote: 'ഓപ്പറേറ്റർ രേഖപ്പെടുത്തിയ ഇന്ധന നില · മാനുവൽ എൻട്രി',
  bookingsTab: 'ബുക്കിംഗ്',
  unknownLabel: 'അജ്ഞാതം',
  naLabel: 'N/A',
  baseLabel: 'അടിസ്ഥാനം',
  qtyLabel: 'അളവ്',
  actualHrsLabel: 'യഥാർത്ഥ മണിക്കൂറുകൾ',
  auditStatTotal: 'ആകെ',
  auditStatSecurity: 'സുരക്ഷ',
  auditStatActors: 'പ്രവർത്തകർ',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'Non-Admin',
  kycDocLicense: 'ലൈസൻസ്',
  kycDocAadhaarFront: 'Aadhaar മുൻഭാഗം',
  kycDocAadhaarBack: 'Aadhaar പിൻഭാഗം',
  kycDocPoliceVerification: 'പോലീസ് സ്ഥിരീകരണം',
  kycVerification: 'KYC പരിശോധന',
  kycNotSubmitted: 'KYC സമർപ്പിച്ചിട്ടില്ല',
  kycUnderReview: 'KYC പരിശോധനയിൽ',
  kycVerified: 'KYC സ്ഥിരീകരിച്ചു',
  kycRejected: 'KYC നിരസിച്ചു',
  kycAadhaarFront: 'Aadhaar മുൻഭാഗം',
  kycAadhaarBack: 'Aadhaar പിൻഭാഗം',
  kycSelfie: 'സെൽഫി',
  kycSubmitBtn: 'KYC രേഖകൾ സമർപ്പിക്കുക',
  kycSubmitSuccess: 'രേഖകൾ സമർപ്പിച്ചു — പരിശോധനയിൽ',
  kycResubmit: 'രേഖകൾ വീണ്ടും സമർപ്പിക്കുക',
  adminKycTitle: 'ക്ലയന്റ് KYC അവലോകനം',
  adminKycAllFilter: 'എല്ലാം',
  adminKycNoSubmissions: 'ഇതുവരെ KYC സമർപ്പണങ്ങൾ ഇല്ല',
  adminOwnerKycTitle: 'ഉടമ KYC അവലോകനം',
  adminOwnerKycNoSubmissions: 'ഇതുവരെ ഉടമ KYC സമർപ്പണങ്ങൾ ഇല്ല',
  adminOperatorKycTitle: 'ഓപ്പറേറ്റർ KYC അവലോകനം',
  adminOperatorKycNoSubmissions: 'ഇതുവരെ ഓപ്പറേറ്റർ KYC സമർപ്പണങ്ങൾ ഇല്ല',
  kycRejectedWarning: 'നിങ്ങളുടെ KYC നിരസിക്കപ്പെട്ടു. ദയവായി രേഖകൾ വീണ്ടും സമർപ്പിക്കുക.',
  kycNotSubmittedHint: 'വിശ്വസനീയമായ അനുഭവത്തിന് KYC പൂർത്തിയാക്കുക.',
  kycPendingHint: 'നിങ്ങളുടെ KYC അവലോകനത്തിലാണ്.',
  kycGoToTab: 'KYC-ലേക്ക് പോകുക',
  adminKycApproveBtn: 'അംഗീകരിക്കുക',
  adminKycRejectBtn: 'നിരസിക്കുക',
  adminKycViewDocs: 'രേഖകൾ കാണുക',
  adminKycRejectReason: 'നിരസിക്കാനുള്ള കാരണം',
  adminKycRereviewBtn: 'വീണ്ടും അവലോകനം',
  kycPan: 'PAN കാർഡ്',
  kycOwnerSubmitSuccess: 'രേഖകൾ സമർപ്പിച്ചു — നിങ്ങളുടെ KYC അവലോകനത്തിലാണ്',
  kycLicense: 'ഡ്രൈവിംഗ് ലൈസൻസ്',
  kycPoliceVerification: 'പോലീസ് സ്ഥിരീകരണം',
  kycOperatorSubmitSuccess: 'രേഖകൾ സമർപ്പിച്ചു — നിങ്ങളുടെ KYC അവലോകനത്തിലാണ്',
  operatorKycRejectedAssign: 'ഈ ഓപ്പറേറ്ററിന്റെ KYC നിരസിച്ചു — വീണ്ടും അംഗീകരിക്കപ്പെടുന്നതുവരെ അവർക്ക് നിയോഗിക്കാൻ കഴിയില്ല.',
  operatorsColOperator: 'ഓപ്പറേറ്റർ',
  operatorsColEmail: 'ഇമെയിൽ',
  operatorsColPhone: 'ഫോൺ',
  operatorsColDocuments: 'രേഖകൾ',
  operatorsColStatus: 'സ്ഥിതി',
  operatorsDocumentsBtn: 'രേഖകൾ ({{count}})',
  operatorsNoResults: 'ഓപ്പറേറ്റർമാർ ഒന്നും കണ്ടില്ല',
  operatorsAllTitle: 'എല്ലാ ഓപ്പറേറ്റർമാരും ({{count}})',
  operatorsKycDialogDesc: 'KYC രേഖകൾ',
  bookingsCountLabel: '{{count}} ബുക്കിംഗുകൾ',
  complianceDates: 'അനുപാലന തീയതികൾ',
  complianceInsurance: 'ഇൻഷുറൻസ്',
  complianceRcBook: 'RC ബുക്ക്',
  compliancePuc: 'PUC',
  complianceNotSet: 'സജ്ജമാക്കിയിട്ടില്ല',
  complianceExpired: 'കാലാവധി കഴിഞ്ഞു',
  complianceExpiringSoon: 'ഉടൻ കാലാവധി',
  complianceExpiringCritical: '7 ദിവസത്തിൽ കാലാവധി',
  complianceValid: 'സാധുതയുള്ളത്',
  complianceUpdateBtn: 'അനുപാലന തീയതികൾ അപ്ഡേറ്റ് ചെയ്യുക',
  complianceSaveBtn: 'സേവ്',
  complianceAlertsTitle: 'അനുപാലന അലേർട്ടുകൾ',
  complianceAllCompliant: 'എല്ലാ മെഷീനുകളും അനുപാലനത്തിൽ ✅',
  complianceColMachine: 'മെഷീൻ',
  complianceColOwner: 'ഉടമ',
  complianceColInsurance: 'ഇൻഷുറൻസ്',
  complianceColRcBook: 'RC ബുക്ക്',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'ആരംഭ തീയതി',
  complianceEndDate: 'അവസാന തീയതി',
  complianceExtractBtn: 'തീയതികൾ സ്വയം പൂരിപ്പിക്കാൻ ഡോക്യുമെന്റ് അപ്‌ലോഡ് ചെയ്യുക',
  complianceExtractSuccess: 'തീയതികൾ എടുത്തു — സേവ് ചെയ്യുന്നതിന് മുമ്പ് പരിശോധിക്കുക',
  complianceExtractError: 'തീയതികൾ എടുക്കാൻ കഴിഞ്ഞില്ല — ദയവായി സ്വയം നൽകുക',
  complianceExtracting: 'ഡോക്യുമെന്റ് വായിക്കുന്നു...',
  serviceHistory: 'സേവാ ചരിത്രം',
  serviceLastService: 'അവസാന സേവ',
  serviceNoRecords: 'ഇതുവരെ സേവാ രേഖകളില്ല',
  serviceNextDue: 'അടുത്ത സേവ കുടിശ്ശിക',
  serviceNextHmr: 'അടുത്ത സേവയിൽ',
  serviceAddLog: 'സേവാ ലോഗ് ചേർക്കുക',
  serviceDate: 'സേവാ തീയതി',
  serviceType: 'സേവാ തരം',
  serviceHmr: 'സേവ HMR',
  serviceNextDate: 'അടുത്ത സേവാ തീയതി',
  serviceWorkDone: 'ചെയ്ത ജോലി',
  serviceNotes: 'കുറിപ്പുകൾ',
  serviceTypeRoutine: 'പതിവ്',
  serviceTypeMajor: 'പ്രധാന',
  serviceTypeBreakdown: 'തകരാർ',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'മറ്റ്',
  serviceOverdue: 'കാലാവധി കഴിഞ്ഞു',
  serviceDueSoon: 'ഉടൻ കുടിശ്ശിക',
  fleetAnalytics: 'ഫ്ലീറ്റ് അനലിറ്റിക്സ്',
  analyticsRevenue: 'ആകെ വരുമാനം',
  analyticsBookings: 'ആകെ ബുക്കിംഗ്',
  analyticsHours: 'ആകെ മണിക്കൂർ',
  analyticsActiveMachines: 'സജീവ മെഷീനുകൾ',
  analyticsMonthlyTrend: 'മാസിക വരുമാന പ്രവണത',
  analyticsMachineTable: 'മെഷീൻ അനുസരിച്ചുള്ള വരുമാനം',
  analyticsNoData: 'ഈ കാലയളവിൽ പൂർത്തിയായ ബുക്കിംഗ് ഇല്ല',
  analyticsLastBooking: 'അവസാന ബുക്കിംഗ്',
  analytics3Months: '3 മാസം',
  analytics6Months: '6 മാസം',
  analytics12Months: '12 മാസം',
  adminAnalytics: 'അനലിറ്റിക്സ്',
  adminFleetTitle: 'ഫ്ലീറ്റ് അനലിറ്റിക്സ്',
  adminFleetPlatformRevenue: 'പ്ലാറ്റ്‌ഫോം വരുമാനം',
  adminFleetActiveOwners: 'സജീവ ഉടമകൾ',
  adminFleetOwnerCol: 'ഉടമ',
  adminFleetMonthlyTrend: 'മാസിക വരുമാന ട്രെൻഡ്',
  adminFleetMachineTable: 'മെഷീൻ അനുസരിച്ചുള്ള വരുമാനം',
  adminFleetNoData: 'ഈ കാലയളവിൽ പൂർത്തിയായ ബുക്കിംഗ് ഇല്ല',
  adminFinancialIntelligence: 'മെഷീൻ സാമ്പത്തിക ബുദ്ധിമത്വം',
  adminTotalInvested: 'ആകെ നിക്ഷേപം',
  adminTotalEarned: 'ആകെ വരുമാനം',
  adminAvgRecovery: 'ശരാശരി തിരിച്ചെടുക്കൽ',
  adminBreakEvenRate: 'ബ്രേക്ക്-ഈവൻ നിരക്ക്',
  adminProfitMargin: 'ലാഭ മാർജിൻ',
  adminNoFinancialData: 'ഇതുവരെ സാമ്പത്തിക ഡാറ്റയുള്ള മെഷീനുകൾ ഇല്ല',
  adminMachineDetail: 'മെഷീൻ വിവരം',
  adminCallOwner: 'ഉടമയെ വിളിക്കുക',
  adminWhatsappOwner: 'WhatsApp ഉടമ',
  adminMarketRates: 'മാർക്കറ്റ് നിരക്ക് സമർപ്പണങ്ങൾ',
  adminMarketRateDelete: 'ഇല്ലാതാക്കുക',
  adminMarketRateDeleteConfirm: 'ഈ മാർക്കറ്റ് നിരക്ക് സമർപ്പണം ഇല്ലാതാക്കണോ?',
  adminMarketRateDeleted: 'മാർക്കറ്റ് നിരക്ക് ഇല്ലാതാക്കി',
  adminMarketRateNoData: 'ഇതുവരെ മാർക്കറ്റ് നിരക്ക് സമർപ്പണങ്ങളില്ല',
  marketRateApprove: 'അംഗീകരിക്കുക',
  marketRateReject: 'നിരസിക്കുക',
  marketRateApproved: 'അംഗീകരിച്ചു',
  marketRateRejected: 'നിരസിച്ചു',
  marketRatePending: 'തീർപ്പുകൽപ്പിക്കാത്തത്',
  marketRateReviewed: 'മാർക്കറ്റ് നിരക്ക് അവലോകനം ചെയ്തു',
  marketRatePendingReview: 'നിങ്ങളുടെ നിരക്ക് സമർപ്പിച്ചു, അഡ്‌മിൻ അവലോകനത്തിനായി തീർപ്പാക്കാതെ കിടക്കുന്നു.',
  marketRateEditApprove: 'തിരുത്തി അംഗീകരിക്കുക',
  marketRateEditMin: 'തിരുത്തിയ ഏറ്റവും കുറഞ്ഞ നിരക്ക് (₹/മണിക്കൂർ)',
  marketRateEditMax: 'തിരുത്തിയ ഏറ്റവും കൂടിയ നിരക്ക് (₹/മണിക്കൂർ)',
  adminPayrollOverview: 'ശമ്പള അവലോകനം',
  adminPayrollTotalOperators: 'ആകെ ഓപ്പറേറ്റർമാർ',
  adminPayrollTotalGross: 'ആകെ നൽകേണ്ട തുക',
  adminPayrollTotalNet: 'ആകെ നെറ്റ് നൽകേണ്ടത്',
  adminPayrollNoData: 'ഈ മാസത്തേക്ക് ശമ്പള ഡാറ്റയില്ല',
  subTabSchedule: 'ഷെഡ്യൂൾ',
  subTabHistory: 'ചരിത്രം',
  subTabAnalytics: 'അനലിറ്റിക്സ്',
  clientAnalyticsTitle: 'ബുക്കിംഗ് അനലിറ്റിക്സ്',
  clientAnalyticsSpend: 'ആകെ ചെലവ്',
  clientAnalyticsHours: 'ആകെ മണിക്കൂർ',
  clientAnalyticsBookings: 'പൂർത്തിയായ ബുക്കിംഗുകൾ',
  clientAnalyticsMachines: 'ഉപയോഗിച്ച മെഷീനുകൾ',
  clientAnalyticsAvgSpend: 'ഓരോ ബുക്കിംഗിനും ശരാശരി',
  clientAnalyticsMonthlyTrend: 'മാസിക ചെലവ് ട്രെൻഡ്',
  clientAnalyticsTopMachines: 'മുൻനിര മെഷീനുകൾ',
  clientAnalyticsNoData: 'ഈ കാലയളവിൽ പൂർത്തിയായ ബുക്കിംഗ് ഇല്ല',
  operatorAnalyticsTitle: 'ജോലി അനലിറ്റിക്സ്',
  operatorAnalyticsPresentDays: 'ഹാജർ ദിവസങ്ങൾ',
  operatorAnalyticsHalfDays: 'അർധ ദിവസം',
  operatorAnalyticsHmr: 'ആകെ HMR',
  operatorAnalyticsJobs: 'പൂർത്തിയായ ജോലികൾ',
  operatorAnalyticsIssues: 'റിപ്പോർട്ട് ചെയ്ത പ്രശ്നങ്ങൾ',
  operatorAnalyticsAvgHmr: 'ശരാശരി HMR/ദിവസം',
  operatorAnalyticsMonthlyTrend: 'മാസിക ജോലി ട്രെൻഡ്',
  operatorAnalyticsIssueBreakdown: 'തരം അനുസരിച്ച് പ്രശ്നങ്ങൾ',
  operatorAnalyticsRecentJobs: 'സമീപകാല ജോലികൾ',
  operatorAnalyticsNoData: 'ഈ കാലയളവിൽ ജോലി രേഖകൾ ഇല്ല',
  adminServiceAlertsTitle: 'സേവന അലേർട്ടുകൾ',
  adminServiceAllOk: 'എല്ലാ മെഷീനുകളുടെയും സേവന റെക്കോർഡുകൾ അപ്‌ഡേറ്റ് ആണ് ✅',
  adminServiceNoRecord: 'റെക്കോർഡുകൾ ഇല്ല',
  adminServiceColLastService: 'അവസാന സേവനം',
  adminServiceColNextDue: 'അടുത്ത Due',
  adminServiceColServiceStatus: 'സേവന നില',
  adminMachinesColMinHrs: 'കുറഞ്ഞ മണി',
  adminMachinesColRateDay: 'നിരക്ക്/ദിവസം',
  adminClientName: 'ക്ലയന്റിന്റെ പേര്',
  adminOwnerName: 'ഉടമയുടെ പേര്',
  adminPayoutWallet: 'പേയ്‌ഔട്ട് വാലറ്റ്',
  adminFooterMachines: 'മെഷീനുകൾ',
  adminFooterClients: 'ക്ലയന്റുകൾ',
  adminFooterOwners: 'ഉടമകൾ',
  auditSeverityCritical: 'ഗുരുതരം',
  auditSeverityHigh: 'ഉയർന്ന',
  auditSeverityMedium: 'ഇടത്തരം',
  auditSeverityNormal: 'സാധാരണ',
  auditCopyEvent: 'ഇവന്റ് പകർത്തുക',
  auditViewDetails: 'വിശദാംശങ്ങൾ കാണുക',
  auditHideDetails: 'വിശദാംശങ്ങൾ മറയ്ക്കുക',
  auditCopyJson: 'JSON പകർത്തുക',
  auditNoLogs: 'ഓഡിറ്റ് ലോഗുകളില്ല',
  auditIntroBanner: 'ലോഗിൻ, അഡ്മിൻ പ്രവർത്തനങ്ങളും സുരക്ഷാ സംഭവങ്ങളും. ഫിൽട്ടറുകൾ ലോഡ് ചെയ്ത ഫലങ്ങളിൽ ബാധകമാണ്; പഴയ വരികൾക്ക് കൂടുതൽ ലോഡ് ചെയ്യുക.',
  auditLoaded: 'ലോഡ് ചെയ്തത്',
  auditMoreAvailable: 'കൂടുതൽ ലഭ്യം',
  auditEndOfList: 'പട്ടിക അവസാനം',
  auditFilterActive: 'ഫിൽട്ടർ സജീവം',
  auditFiltersActive: 'ഫിൽട്ടറുകൾ സജീവം',
  auditSeverityBreakdown: 'തീവ്രത വിഭജനം (നിലവിലെ പട്ടിക)',
  auditPressSlash: 'ആക്ഷൻ ഫിൽട്ടറിൽ ഫോക്കസ് ചെയ്യാൻ / അമർത്തുക',
  auditFilters: 'ഫിൽട്ടറുകൾ',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'എല്ലാ റോളുകളും',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'മെറ്റാഡാറ്റ JSON തിരയുക',
  auditFilterFromPlaceholder: 'ആരംഭ തീയതിയും സമയവും',
  auditFilterToPlaceholder: 'അവസാന തീയതിയും സമയവും',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'സമയ മേഖല:',
  auditTimezoneSuffix: '(പ്രാദേശിക)',
  auditHideCsvOptions: 'CSV കോളം ഓപ്ഷനുകൾ മറയ്ക്കുക',
  auditShowCsvOptions: 'CSV കോളം ഓപ്ഷനുകൾ കാണിക്കുക',
  auditCsvColCreatedAt: 'സൃഷ്ടി സമയം',
  auditCsvColAction: 'പ്രവർത്തനം',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'മെറ്റാഡാറ്റ',
  auditFooterLoaded: 'ലോഡ് ചെയ്തത്',
  auditFooterLogs: 'ഓഡിറ്റ് ലോഗുകൾ',
  auditFooterMoreAvailable: '(കൂടുതൽ ലഭ്യം)',
  auditFooterAllLoaded: '(എല്ലാം ലോഡ് ചെയ്തത്)',
  auditActor: 'ആക്ടർ',
  auditEntity: 'എന്റിറ്റി',
  auditEventLog: 'ഇവന്റ് ലോഗ്',
  notificationCenter: 'അറിയിപ്പുകൾ',
  notifChannelAll: 'എല്ലാം',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'ഇമെയിൽ',
  notifChannelPush: 'പുഷ്',
  notifChannelSms: 'SMS',
  notifStatusSent: 'അയച്ചു',
  notifStatusFailed: 'പരാജയം',
  notifStatusPending: 'തീർപ്പാക്കാത്ത',
  notifEmpty: 'ഇതുവരെ അറിയിപ്പുകളില്ല',
  notifLoadMore: 'കൂടുതൽ ലോഡ് ചെയ്യുക',
  adminNotifLog: 'അറിയിപ്പ് ലോഗ്',
  adminNotifColUser: 'ഉപയോക്താവ്',
  adminNotifColRole: 'പങ്ക്',
  adminNotifNoData: 'ഇതുവരെ അറിയിപ്പുകൾ ലോഗ് ചെയ്തിട്ടില്ല',
  etaOwnerApproval: 'ഉടമയുടെ അംഗീകാരത്തിനായി കാത്തിരിക്കുന്നു',
  etaWorkInProgress: 'അനുമാനിച്ച പൂർത്തീകരണം',
  etaPaymentDeadline: 'പേയ്‌മെന്റ് സ്ഥിരീകരണ അവസാന തീയതി',
  etaWorkCompleted: 'ജോലി പൂർത്തിയായി',
  etaDisputeReview: 'DE ടീം വിവാദം പരിശോധിക്കുന്നു',
  etaMinutesRemaining: '{n} മിനിറ്റ് ബാക്കി',
  etaHoursRemaining: '{n} മണി ബാക്കി',
  txRecharge: 'വാലറ്റ് റീചാർജ്',
  txBookingAdvance: 'ബുക്കിംഗ് അഡ്വാൻസ്',
  txBookingPayment: 'ബുക്കിംഗ് പേയ്‌മെന്റ്',
  txSettlement: 'സെറ്റിൽമെന്റ്',
  txRefund: 'റീഫണ്ട്',
  txPenalty: 'പിഴ',
  txCommission: 'കമ്മീഷൻ',
  tacTitle: "നിബന്ധനകളും വ്യവസ്ഥകളും",
  tacPrivacy: "സ്വകാര്യതാ നയം",
  tacRefund: "റീഫണ്ട് നയം",
  tacCancellation: "റദ്ദാക്കൽ നയം",
  tacServiceDelivery: "സേവന ഡെലിവറി നയം",
  tacIntro: "ബുക്കിംഗിന് മുമ്പ് ഞങ്ങളുടെ നയങ്ങൾ കാണുക",
  tacBannerTitle: "നിബന്ധനകളുടെ അപ്‌ഡേറ്റ് ലഭ്യം",
  tacBannerOpen: "നിബന്ധനകൾ തുറക്കുക",
  tacBannerAgree: "ഞാൻ വായിച്ച് സമ്മതിക്കുന്നു",
  tacBannerLater: "പിന്നീട്",
  clientPoliciesTitle: "ക്ലയന്റ് നയങ്ങൾ",
  machineGroupAvailable: "ലഭ്യം",
  machineGroupBusy: "തിരക്കില്‍",
  dewateringReferral: "ഡീവാട്ടറിംഗ് (പമ്പ്) സേവനം വേണോ? MachineOS ഉടൻ പമ്പ് കരാറുകാരുടെ സേവനങ്ങൾ ചേർക്കും. റഫറലിന് സപ്പോർട്ട് ബന്ധപ്പെടുക.",
  noActiveWork: "ഈ മാസം സജീവ ജോലിയില്ല",
  accountTab: "അക്കൗണ്ട്",
  recentActivity: "സമീപകാല പ്രവർത്തനം",
  goodMorning: "സുപ്രഭാതം",
  goodAfternoon: "ശുഭ ഉച്ചയ്ക്ക്",
  goodEvening: "ശുഭ സന്ധ്യ",
  thisMonthEarned: 'This month earned',
  standardBookings: 'Standard bookings',
  activeContracts: 'Active contracts',
  contractsOngoing: 'Contracts ongoing',
  noActiveContracts: 'None this period',
  quotationsPending: 'Quotations awaiting reply',
  allUpToDate: 'All bookings up to date',
  noBookingsInPeriod: 'No bookings in this period',
  contractBookings: 'Contract bookings',
  noContractsInPeriod: 'No contracts in this period',
  mobilizationReleased: 'Mobilization released',
  pendingRelease: 'Pending release',
  raBills: 'RA-bills',
  disputed: 'Disputed',
  all: 'All',
  completed: 'Completed',
};
